import { useQuery } from '@apollo/client';
import SalePaymentMethodsQuery from './SalePaymentMethodsQuery';

type result = {
  loading: boolean;
  paymentMethods?: any;
};

interface ISalePaymentMethodsConnectorApollo {
  children: (result: result) => React.ReactElement;
  amount: number;
}

const SalePaymentMethodsConnectorApollo: React.FC<ISalePaymentMethodsConnectorApollo> = ({
  children,
  amount,
}) => {
  const { loading, error, data } = useQuery(SalePaymentMethodsQuery, {
    variables: {
      amount,
    },
  });

  const result: result = {
    loading,
  };

  if (error) {
    throw error;
  }

  if (!loading) {
    const paymentMethods = data.sale.payment.methods;
    const notAvaiblePaymentMethods = ['2_b']; // 2_b means traditional transfer

    const filteredPaymentMethods = paymentMethods.filter((method: any) => {
      const value = `${method.methodId}_${method.channelId}`;
      if (method.__typename === 'SaleMethod' && !notAvaiblePaymentMethods.includes(value)) {
        const isMacLike = /(Mac|iPhone|iPod|iPad)/i.test(navigator.userAgent);
        const isChrome =
          /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.userAgent);
        const isSafari = /Safari/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent);
        const isMobileChrome = isChrome && /Mobile/.test(navigator.userAgent);

        // Apple Pay filtering: show only on Apple devices in Safari or mobile Chrome
        if (method.isApplePay) {
          const shouldShowApplePay = isMacLike && (isSafari || isMobileChrome);
          if (!shouldShowApplePay) {
            return null;
          }
        }

        return method;
      }
    });

    result.paymentMethods = filteredPaymentMethods;
  }

  return children(result);
};

export default SalePaymentMethodsConnectorApollo;
